export enum MapTileFormats {
  XYZ = 1,
  TMS = 2,
  Quadkey = 3,
  WMTS = 4
};
